import axios from "../../axios";

const getRequests = async (vendor_id) => {
  try {
    const { data } = await axios.get(`/vendors/requests/${vendor_id}`);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

const getRequestItems = async (id) => {
  try {
    const { data } = await axios.get(`/requests/request_items/${id}`);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

const getInventoryByVendor = async (vendor_id, status) => {
  status = status ? `?status[$eq]=${status}` : '';
  try {
    const { data } = await axios.get(`/vendors/inventory/${vendor_id}${status}`);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

const getConsignedByVendor = async (vendor_id) => {
  try {
    const { data } = await axios.get(`/vendors/consigned/${vendor_id}`);
    return data?.inventory || [];
  } catch (e) {
    return [];
    console.log(e);
  }
};

const getVendorIntegration = async (vendor_id) => {
  try {
    const { data } = await axios.get(`/vendors/integration/${vendor_id}`);
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
}

const uploadPackingList = async ({file, vendor_id, vendor_name, additional_instructions}) => {
  const body = new FormData();
  body.append('file', file);
  body.append('vendor_id', vendor_id);
  body.append('vendor_name', vendor_name);
  body.append('additional_instructions', additional_instructions);

  try {
    const result = await axios.post('/inventory/extract', body, { timeout: 120000 });

    let payload = result?.data;
    let { data } = payload;
    return {
      items: Array.isArray(data.items) ? data.items : [],
      warnings: Array.isArray(data.warnings) ? data.warnings : [],
      document: {
        vendor_name: data.vendor_name,
        document_number: data.document_number,
        document_date: data.document_date,
        document_type: data.document_type,
        currency: data.currency,
        document_total: data.document_total,
        layout_notes: data.layout_notes,
      },
    };
  } catch (e) {
    console.log(e, "error");

    if (e.code === 'ECONNABORTED') {
      throw new Error('That file took too long to read. Try a smaller document.');
    } else {
      throw new Error(`Couldn't read that file. Try again.`);
    }
  }
};

export { getRequests, getRequestItems, getInventoryByVendor, getConsignedByVendor, uploadPackingList, getVendorIntegration };